"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Progress = _interopRequireDefault(require("./Progress"));

exports.default = _Progress.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/modules/Progress/index.js
// module id = 1515
// module chunks = 0